import {RouteObject} from 'react-router-dom';
import React from 'react';

import * as factories from 'main/factories/pages';
import {PublicRoutes} from 'main/proxies';
import {
	SignUpEnum,
	ForgotPasswordEnum,
	FirstAccessEnum,
	SignInEnum,
	AuthorizationB2BEnum,
} from 'presentation/constants';
import {AuthorizationB2B} from 'presentation/pages/public/authorization-b2b';

export function getPublicRoutes() {
	const routeElements = {
		element: <PublicRoutes />,
		children: [
			{
				index: true,
				element: <factories.MakeSignIn />,
			},
			{
				path: SignUpEnum.SIGN_UP,
				element: <factories.MakeSignUp />,
			},
			{
				path: ForgotPasswordEnum.FORGOT_PASSWORD,
				element: <factories.MakeForgotPasswordPage />,
			},
			{
				path: FirstAccessEnum.FIRST_ACCESS,
				element: <factories.MakeFirstAccess />,
			},
		],
	};
	const publicRoutes: RouteObject[] = [
		{
			path: SignInEnum.SIGN_IN,
			...routeElements,
		},
		{
			path: SignInEnum.LOGIN,
			...routeElements,
		},
		{
			path: AuthorizationB2BEnum.AUTHORIZATION,
			element: <AuthorizationB2B />,
		},
	];

	return publicRoutes;
}
